export enum MarkerInOut {
  In,
  Out,
}
